import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TiktokIcon, TelegramIcon, WhatsappIcon } from "@/svgs";
import "./Footer.css";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const [activeSections, setActiveSections] = useState<{
    [key: string]: boolean;
  }>({
    navegacao: false,
    suporte: false,
    legal: false,
    app: false,
  });

  const toggleSection = (section: string) => {
    if (window.innerWidth <= 768) {
      setActiveSections((prev) => ({ ...prev, [section]: !prev[section] }));
    }
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-brand-column">
          <a
            href="/"
            className="footer-logo"
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
            }}
          >
            <img
              src="/mimocupido-logo.png"
              alt="Mimo Cupido"
              className="footer-logo-icon"
            />
            <span className="footer-brand-text">MIMO CUPIDO</span>
          </a>
          <p className="footer-description">
            Conectamos pessoas que buscam relacionamentos reais, com respeito,
            segurança e compatibilidade.
          </p>
          <div className="social-icons">
            <a
              href={process.env.REACT_APP_WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsappIcon />
            </a>
            <a
              href={process.env.REACT_APP_TIKTOK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TiktokIcon />
            </a>
            <a
              href={process.env.REACT_APP_TELEGRAM}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TelegramIcon />
            </a>
          </div>
        </div>

        <div
          className={`footer-column ${activeSections.navegacao ? "is-open" : ""}`}
        >
          <h4
            className="footer-column-title"
            onClick={() => toggleSection("navegacao")}
          >
            Navegação <span className="accordion-arrow"></span>
          </h4>
          <div className="footer-column-links">
            <a
              href="/conexoes-verdadeiras"
              onClick={(e) => {
                e.preventDefault();
                navigate("/conexoes-verdadeiras");
              }}
            >
              Conexões Verdadeiras
            </a>
            <a
              href="/relacionamentos-exclusivos"
              onClick={(e) => {
                e.preventDefault();
                navigate("/relacionamentos-exclusivos");
              }}
            >
              Relacionamentos Exclusivos
            </a>
            <a
              href="/compatibilidade-e-afinidades"
              onClick={(e) => {
                e.preventDefault();
                navigate("/compatibilidade-e-afinidades");
              }}
            >
              Compatibilidade e Afinidades
            </a>
            <a
              href="/planos"
              onClick={(e) => {
                e.preventDefault();
                navigate("/planos");
              }}
            >
              Planos
            </a>
          </div>
        </div>

        <div
          className={`footer-column ${activeSections.suporte ? "is-open" : ""}`}
        >
          <h4
            className="footer-column-title"
            onClick={() => toggleSection("suporte")}
          >
            Suporte <span className="accordion-arrow"></span>
          </h4>
          <div className="footer-column-links">
            {/* <a
              href="/central-de-ajuda"
              onClick={(e) => {
                e.preventDefault();
                navigate("/central-de-ajuda");
              }}
            >
              Central de Ajuda
            </a> */}
            {/* <a
              href="/faq"
              onClick={(e) => {
                e.preventDefault();
                navigate("/faq");
              }}
            >
              Perguntas Frequentes
            </a> */}
            <a
              href="/seguranca"
              onClick={(e) => {
                e.preventDefault();
                navigate("/seguranca");
              }}
            >
              Dicas de Segurança
            </a>
            {/* <a
              href="/fale-conosco"
              onClick={(e) => {
                e.preventDefault();
                navigate("/fale-conosco");
              }}
            >
              Fale Conosco
            </a> */}
          </div>
        </div>

        <div
          className={`footer-column ${activeSections.legal ? "is-open" : ""}`}
        >
          <h4
            className="footer-column-title"
            onClick={() => toggleSection("legal")}
          >
            Legal <span className="accordion-arrow"></span>
          </h4>
          <div className="footer-column-links">
            <a
              href="/termos-e-condicoes"
              onClick={(e) => {
                e.preventDefault();
                navigate("/termos-e-condicoes");
              }}
            >
              Termos de Uso
            </a>
            <a
              href="/politica-de-privacidade"
              onClick={(e) => {
                e.preventDefault();
                navigate("/politica-de-privacidade");
              }}
            >
              Política de Privacidade
            </a>
            {/* <a
              href="/politica-de-cookies"
              onClick={(e) => {
                e.preventDefault();
                navigate("/politica-de-cookies");
              }}
            >
              Política de Cookies
            </a> */}
            <a
              href="/diretrizes"
              onClick={(e) => {
                e.preventDefault();
                navigate("/diretrizes");
              }}
            >
              Diretrizes da Comunidade
            </a>
          </div>
        </div>

        {/* <div
          className={`footer-column download-column ${activeSections.app ? "is-open" : ""}`}
        >
          <h4
            className="footer-column-title"
            onClick={() => toggleSection("app")}
          >
            Baixe nosso app <span className="accordion-arrow"></span>
          </h4>
          <div className="footer-column-links app-links-container">
            <p className="app-subtitle">Disponível para iOS e Android</p>
            <div className="app-badges">
              <a href="#" className="app-badge-btn">
                <img src="/btn-appstore.png" alt="Disponível na App Store" />
              </a>
              <a href="#" className="app-badge-btn">
                <img
                  src="/btn-googleplay.png"
                  alt="Disponível no Google Play"
                />
              </a>
            </div>
          </div>
        </div> */}
      </div>

      {/* Direitos Autorais */}
      <div className="footer-bottom">
        <p>© {currentYear} Mimo Cupido. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
